import React, { useState } from 'react';
import './Header.css';

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <header className="glass-navbar-container">
      <nav className="navbar" style={{color:"white"}}>
        {/* LOGO SECTION */}
        <div className="brand-logo">
          <img 
            src="./images/logo.svg" 
            alt="ATZ Pay Logo" 
            className="logo-img" 
          />
         
        </div>

        {/* DESKTOP NAVIGATION LINKS */}
        <div className={`nav-links ${isMobileMenuOpen ? 'mobile-active' : ''}`}>
          <a href="#home" className="nav-item active">
            Home
            <span className="active-indicator"></span>
          </a>
          <a href="#contact" className="nav-item" style={{color:"white"}}>
            Contact
          </a>
        </div>

        {/* RIGHT ACTION BUTTONS */}
        <div className="nav-actions">
          <button className="btn-help">
            <svg 
              className="headset-svg" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            >
              <path d="M3 18v-6a9 9 0 0 1 18 0v6"></path>
              <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3z"></path>
              <path d="M3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"></path>
            </svg>
            <span>Support</span>
          </button>

          <div className="glow-button-wrapper">
            <button className="btn-download">Open Wallet</button>
          </div>

          {/* HAMBURGER TOGGLE FOR MOBILE */}
          <button 
            className={`hamburger-menu ${isMobileMenuOpen ? 'open' : ''}`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle navigation"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;